import { useEffect } from 'react';

// 'KeyD' et 'KeyS' sont déjà pris par debugStore.js (Ctrl+Alt+Shift+D/S démarre/arrête l'enregistrement debug).
// event.code (touche physique) plutôt que event.key : Ctrl+Alt = AltGr sur un clavier AZERTY, ce qui
// change la valeur de event.key une fois combiné à Shift. event.code reste stable quel que soit le layout.
const SHORTCUT_CODE = 'KeyT';
const DEV_TOOLS_PATH = '/dev-tools/';

const DevToolsShortcutGate = () => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey && event.altKey && event.shiftKey && event.code === SHORTCUT_CODE) {
        event.preventDefault();
        window.open(DEV_TOOLS_PATH, '_blank', 'noopener,noreferrer');
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return null;
};

export default DevToolsShortcutGate;
